/**
 * 로그인 후 user 정보 저장함
 */

import { ILodList } from "interface/home";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SetLodState {
  lod:
    | (ILodList & {
        code: string;
        en: string;
        ko: string;
        value: string;
      })
    | null;
  setLod: (value: any) => void;
}

const useLodStore = create<SetLodState>()(
  persist(
    (set) => ({
      lod: null,

      setLod: (value) => {
        set({ lod: value });
      },
    }),
    {
      name: "lod-storage",
      partialize: (state) => ({
        lod: state.lod,
      }),
    }
  )
);

export default useLodStore;
